module.exports = __webpack_public_path__ + "img/hat.17a74e5c.png";